import { IS_SSO_BRIDGE } from "constants/app.constants";
import { selectActiveSetting, usePanelStore } from "stores/panelStore";

import { NavigationBar } from "components/navigation";
import { ProjectProvider } from "components/project/projects/context";
import DocumentationModal from "components/user-documentation/DocumentationModal";

import { ErrorBoundary } from "../base";
import { DeveloperApiTokenManagement } from "./DeveloperApiTokenManagement";
import { GeoModelAccess } from "./GeoModelAccess";
import { GeoModelDefaults } from "./GeoModelDefaults";
import OrganizationBillingHistory from "./OrganizationBillingHistory";
import OrganizationDataSources from "./OrganizationDataSources";
import OrganizationDisplaySettings from "./OrganizationDisplaySettings";
import { OrganizationGeoCalculationJobs } from "./OrganizationGeoCalculationJobs";
import { OrganizationGeoModelConfigurations } from "./OrganizationGeoModelConfigurations";
import { OrganizationGeoSimulationJobs } from "./OrganizationGeoSimulationJobs";
import OrganizationMapDefaults from "./OrganizationMapDefaults";
import OrganizationMembers from "./OrganizationMembers";
import OrganizationProfile from "./OrganizationProfile";
import OrganizationSecurity from "./OrganizationSecurity";
import "./OrganizationSettingsLayout.scss";
import OrganizationSettingsSideNav from "./OrganizationSettingsSideNav";
import OrganizationSubscription from "./OrganizationSubscription";
import OrganizationForecasts from "./forecasts/OrganizationForecasts";
import OrganizationShapefiles from "./org-shapefiles/OrganizationShapefiles";
import SystemShapefiles from "./org-shapefiles/SystemShapefiles";

export default function OrganizationSettingsLayout({ authenticated: isAuthenticated }) {
  const activeSetting = usePanelStore(selectActiveSetting);
  const components = {
    OrganizationProfile: <OrganizationProfile />,
    OrganizationSecurity: <OrganizationSecurity />,
    OrganizationForecasts: <OrganizationForecasts />,
    OrganizationShapefiles: (
      <ProjectProvider>
        <OrganizationShapefiles />
      </ProjectProvider>
    ),
    SystemShapefiles: (
      <ProjectProvider>
        <SystemShapefiles />
      </ProjectProvider>
    ),
    OrganizationDisplaySettings: <OrganizationDisplaySettings />,
    OrganizationSubscription: <OrganizationSubscription />,
    OrganizationMembers: IS_SSO_BRIDGE ? null : <OrganizationMembers />,
    OrganizationBillingHistory: <OrganizationBillingHistory />,
    OrganizationDataSources: <OrganizationDataSources />,
    DeveloperApiTokenManagement: <DeveloperApiTokenManagement />,
    OrganizationGeoCalculationJobs: <OrganizationGeoCalculationJobs />,
    OrganizationGeoSimulationJobs: <OrganizationGeoSimulationJobs />,
    OrganizationGeoModelConfigurations: <OrganizationGeoModelConfigurations />,
    GeoModelAccess: <GeoModelAccess />,
    GeoModelDefaults: <GeoModelDefaults />,
    OrganizationMapDefaults: <OrganizationMapDefaults />
  };
  return (
    <div className="SettingsOverlay">
      <div className="OrganizationSettingsLayout">
        <NavigationBar showDashboardButtons={false} />
        <div className="settings-content">
          <div className="settings-side-bar">
            <OrganizationSettingsSideNav />
          </div>
          <div className="organizationAccount">
            <ErrorBoundary>
              {isAuthenticated ? components[activeSetting] : null}
            </ErrorBoundary>
          </div>
        </div>
        <DocumentationModal />
      </div>
    </div>
  );
}
